export const BASE_URL = "/customers";
export const BASE_URL_NEW = "/landing";
export const BASE_URL2 = "/api/lead/roopya/create";
//export const ADD_JOURNEY = BASE_URL + "/api/v2/customer/lead/add/";
export const ADD_JOURNEY = "/api/v2/customers/customers/add-customers";
export const GET_OTP_URL = "/api/v2/customers/customers/send-otp";
export const VERIFY_OTP_URL = "/api/v2/customers/customers-otp/verifiy";
// export const VERIFY_OTP_URL = BASE_URL + "/api/v2/customer/lead/otp/verifiy";
// export const RESEND_OTP_URL = BASE_URL + "/api/v2/customer/lead/otp/resend";
export const   RESEND_OTP_URL = "/api/v2/customers/customers/resend-otp";
export const JOURNEY_FILEDS = BASE_URL + "/api/v2/customer/fields";
export const BUREAU_AUTO_PULL = BASE_URL + "/api/v2/bank/checkAutoBureauPull";
export const BASE_URL_FILES = "http://localhost:5000/";
export const REAL_TIME_LEAD_PUSH_URL =
  BASE_URL + "/api/v2/bank/realTimeLead/push";
export const GET_PROFILE_DETAILS = "/api/v2f";
export const CREDIT_DETAILS = "/api/v2/customers/crif";
export const CREDIT_DETAILS_DB = "/api/v2/customers/crif/detail";
export const CustomersLogo = "/api/v2/partner/partner-getOrganizationDetails";
export const Pre_Approval = "/api/v2/customers/getPreApprovedLoans";